import { NavLink, useLocation } from "react-router-dom";
import { Home, Receipt, Sparkles, Target, User } from "lucide-react";

const items = [
  { to: "/app", label: "Home", icon: Home, testId: "nav-home", end: true },
  { to: "/app/transactions", label: "Transactions", icon: Receipt, testId: "nav-transactions" },
  { to: "/app/insights", label: "Insights", icon: Sparkles, testId: "nav-insights" },
  { to: "/app/goals", label: "Goals", icon: Target, testId: "nav-goals" },
  { to: "/app/profile", label: "Profile", icon: User, testId: "nav-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 h-20 backdrop-blur-xl bg-white/85 border-t border-slate-200 flex justify-around items-center px-2 pb-safe z-50 max-w-md mx-auto"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {items.map(({ to, label, icon: Icon, testId, end }) => {
        const active = end ? pathname === to : pathname.startsWith(to);
        return (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testId}
            className={`flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors duration-200 ${active ? "text-slate-900" : "text-slate-400"}`}
          >
            <Icon size={22} strokeWidth={active ? 2.25 : 1.5} />
            <span className={`text-[11px] tracking-wide ${active ? "font-semibold" : "font-medium"}`}>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
